import React from "react";
import Layout from "../../../../../Components/Layout/Layout";

import TopBanner from "./Components/TopBanner";
import QuizTabs from "./Components/QuizTabs";
import { useLocation } from "react-router";

const ChampionDetails = () => {

  const location = useLocation()
  const data = location.state?.data;

  return (
    <Layout page="learningPrograms" title="Learning Programs">
      <TopBanner data={data} />
      <QuizTabs data={data} />
    </Layout>
  );
};

export default ChampionDetails;
